import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import LeadSectionContainer from "common/components/leads/LeadSectionContainer";
import { Button } from "common/components/ui/Button";
import Skeleton from "common/components/ui/Skeleton";
import { getMonthName } from "common/helpers/utils";
import type { DetailedLead } from "common/types";

import type { JSX } from "react";

const aboutValues: {
  label: string;
  getValue: (lead: DetailedLead) => JSX.Element;
}[] = [
  {
    label: "LinkedIn profile",
    getValue: ({ public_identifier }) => (
      <Button
        rightIcon={<ArrowUpRight />}
        variant="link-purple"
        size="sm"
        asChild
      >
        <Link
          target="_blank"
          to={`https://linkedin.com/in/${public_identifier}`}
          rel="noreferrer"
        >
          View profile
        </Link>
      </Button>
    ),
  },
  {
    label: "Birthday",
    getValue: ({ birthday }) => (
      <span>
        {birthday ? `${birthday.day} ${getMonthName(birthday.month - 1)}` : "-"}
      </span>
    ),
  },
  { label: "Email", getValue: ({ email }) => <span>{email || "-"}</span> },
  {
    label: "Location",
    getValue: ({ location }) => <span>{location ? location.name : "-"}</span>,
  },
  {
    label: "Phone",
    getValue: ({ phones }) => (
      <span>{phones.length ? phones[0].number.toString() : "-"}</span>
    ),
  },
];
export default function About({
  lead,
  isLoading,
  hasBorder,
}: {
  lead: DetailedLead;
  isLoading: boolean;
  hasBorder: boolean;
}) {
  return (
    <LeadSectionContainer title="About" isColumn hasBorder={hasBorder}>
      {aboutValues.map(({ label, getValue }) => (
        <div className="flex justify-between text-button-xs" key={label}>
          <span className="text-black-500">{label}</span>
          {isLoading ? <Skeleton className="h-4 w-28" /> : getValue(lead)}
        </div>
      ))}
    </LeadSectionContainer>
  );
}
